<template>
	<component 
		v-if="component" 
		:is="component" 
		:data="data" />
</template>

<script>
import FlexibleContentBlock from '../../FlexibleContentBlock'
export default {
	extends: FlexibleContentBlock,
	name: 'dynamic-overlay-block',
	props: ['data'],
	computed: {
		loader() {
			if (!this.type) {
				return null
			}
			if(this.type==='TextWysiwyg') {
				return () => import(`./content/TextWysiwyg`)
			}
			if(this.type==='Table') {
				return () => import(`../table/${this.type}`)
			}
			return () => import(`./content/${this.type}`)
		},
	}
}
</script>